export const sectionsInfo = {
  dependents_info: {
    name: 'Dependentes',
    columns: {
      code: { name: 'Código', type: 'integer' },
      name: { name: 'Nome', type: 'name' },
      cpf: { name: 'CPF', type: 'cpf' },
      birth_date: { name: 'Data de Nascimento', type: 'date' },
      email: { name: 'Email', type: 'name' },
      race_or_color: { name: 'Raça/Cor', type: 'name' },
      dependent_lives_with_holder: { name: 'Mora com o Titular?', type: 'boolean' },
    },
    total_deduction_value: { name: 'Total de Dedução com Dependentes', type: 'currency' },
  },
  income_from_legal_person_to_holder: {
    name: 'Rendimentos Tributáveis Recebidos de Pessoa Jurídica pelo Titular',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      income_from_legal_person: {
        name: 'REND. RECEBIDOS DE PES. JURÍDICA',
        type: 'currency',
        total_value_column: 'Total de Rend. Recebidos de Pes. Jurídica',
      },
      official_social_security_contribution: {
        name: 'CONTR. PREVID. OFICIAL',
        type: 'currency',
        total_value_column: 'Total de Contr. Previd. Oficial',
      },
      tax_withheld_at_source: {
        name: 'IMPOSTO RETIDO NA FONTE',
        type: 'currency',
        total_value_column: 'Total em Imposto Retido na Fonte',
      },
      thirteenth_salary: {
        name: '13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em 13º Salário',
      },
      irrf_on_thirteenth_salary: {
        name: 'IRRF SOBRE 13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em IRRF Sobre 13º Salário',
      },
      cpf_cnpj: { name: 'CNPJ/CPF', type: 'cpf_cnpj' },
    },
  },
  income_from_legal_person_to_dependents: {
    name: 'Rendimentos Tributáveis Recebidos de Pessoas Jurídicas pelos Dependentes',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      income_from_legal_person: {
        name: 'REND. RECEBIDOS DE PES. JURÍDICA',
        type: 'currency',
        total_value_column: 'Total de Rend. Recebidos de Pes. Jurídica',
      },
      official_social_security_contribution: {
        name: 'CONTR. PREVID. OFICIAL',
        type: 'currency',
        total_value_column: 'Total de Contr. Previd. Oficial',
      },
      tax_withheld_at_source: {
        name: 'IMPOSTO RETIDO NA FONTE',
        type: 'currency',
        total_value_column: 'Total em Imposto Retido na Fonte',
      },
      thirteenth_salary: {
        name: '13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em 13º Salário',
      },
      irrf_on_thirteenth_salary: {
        name: 'IRRF SOBRE 13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em IRRF Sobre 13º Salário',
      },
      cpf_cnpj: { name: 'CNPJ/CPF', type: 'cpf_cnpj' },
      dependent_cpf: { name: 'CPF DO DEPENDENTE', type: 'cpf' },
    },
  },
  income_from_legal_person_to_holder_with_suspended_requirements: {
    name:
      'Rendimentos Tributáveis Recebidos de Pessoa Jurídica pelo Titular (Imposto com Exigibilidade Suspensa)',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_with_suspended_requirements: {
        name: 'RENDIMENTOS TRIBUTÁVEIS',
        type: 'currency',
        total_value_column: 'Total de Rendimentos Tributáveis',
      },
      court_deposits_of_the_tax: {
        name: 'DEPÓSITOS JUDICIAIS DO IMPOSTO',
        type: 'currency',
        total_value_column: 'Total em Depósitos Judiciais de Impostos',
      },
    },
  },
  income_from_legal_person_to_dependents_with_suspended_requirements: {
    name:
      'Rendimentos Tributáveis Recebidos de Pessoa Jurídica pelos Dependentes (Imposto com Exigibilidade Suspensa)',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_with_suspended_requirements: {
        name: 'RENDIMENTOS TRIBUTÁVEIS',
        type: 'currency',
        total_value_column: 'Total de Rendimentos Tributáveis',
      },
      court_deposits_of_the_tax: {
        name: 'DEPÓSITOS JUDICIAIS DO IMPOSTO',
        type: 'currency',
        total_value_column: 'Total em Depósitos Judiciais de Impostos',
      },
      dependent_cpf: { name: 'CPF DO DEPENDENTE', type: 'cpf' },
    },
  },
  accumulated_income_from_legal_person_to_holder: {
    name: 'Rendimentos Recebidos Acumuladamente de Pessoa Jurídica pelo Titular',
    columns: {
      payer_name: { name: 'Nome da Fonte Pagadora', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_total: {
        name: 'Rend. Tributável Total',
        total_value_column: 'Total em Rend. Tributáveis',
        type: 'currency',
      },
      official_social_security_contribution: {
        name: 'Contrib. Prev. Oficial',
        total_value_column: 'Total em Contrib. Prev. Oficial',
        type: 'currency',
      },
      alimony: {
        name: 'Pensão Alimentícia',
        total_value_column: 'Total em Pensão Alimentícia',
        type: 'currency',
      },
      tax_withheld_at_source: {
        name: 'Imposto Retido na Fonte',
        total_value_column: 'Total em Imposto Retido na Fonte',
        type: 'currency',
      },
      tax_option: { name: 'Opção de Tributação', type: 'name', isHorizontal: true },
      month_of_receipt: { name: 'Mês Recebimento', type: 'name', isHorizontal: true },
      amount_received_related_to_interest: {
        name: 'Valor Referente a Juros',
        type: 'currency',
        isHorizontal: true,
      },
      number_of_months: { name: 'Nº de Meses', type: 'float', isHorizontal: true },
      tax_due_rra: { name: 'Imposto Devido RRA', type: 'currency', isHorizontal: true },
      exempt_portion_65_years: { name: 'Isenção +65 anos', type: 'currency', isHorizontal: true },
      feeding: {
        name: 'Alimentando',
        type: 'inner_table',
        columns: {
          name: { name: 'Nome', type: 'name' },
          value: { name: 'Valor', type: 'currency' },
        },
      },
    },
  },
  accumulated_income_from_legal_person_to_dependents: {
    name: 'Rendimentos Recebidos Acumuladamente de Pessoa Jurídica pelos Dependentes',
    columns: {
      payer_name: { name: 'Nome da Fonte Pagadora', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_total: {
        name: 'Rend. Tributável Total',
        total_value_column: 'Total em Rend. Tributáveis',
        type: 'currency',
      },
      official_social_security_contribution: {
        name: 'Contrib. Prev. Oficial',
        total_value_column: 'Total em Contrib. Prev. Oficial',
        type: 'currency',
      },
      alimony: {
        name: 'Pensão Alimentícia',
        total_value_column: 'Total em Pensão Alimentícia',
        type: 'currency',
      },
      tax_withheld_at_source: {
        name: 'Imposto Retido na Fonte',
        total_value_column: 'Total em Imposto Retido na Fonte',
        type: 'currency',
      },
      tax_option: { name: 'Opção de Tributação', type: 'name', isHorizontal: true },
      month_of_receipt: { name: 'Mês Recebimento', type: 'name', isHorizontal: true },
      amount_received_related_to_interest: {
        name: 'Valor Referente a Juros',
        type: 'currency',
        isHorizontal: true,
      },
      number_of_months: { name: 'Nº de Meses', type: 'float', isHorizontal: true },
      tax_due_rra: { name: 'Imposto Devido RRA', type: 'currency', isHorizontal: true },
      exempt_portion_65_years: { name: 'Isenção +65 anos', type: 'currency', isHorizontal: true },
      feeding: {
        name: 'Alimentando',
        type: 'inner_table',
        columns: {
          name: { name: 'Nome', type: 'name' },
          value: { name: 'Valor', type: 'currency' },
        },
      },
    },
  },

  rural_income_and_expenditure_in_brazil: {
    name: 'Rendimentos e Despesas Rurais - Brasil',
    columns: {
      month: { name: 'Mês', type: 'name' },
      gross_revenue: {
        name: 'Receita Bruta',
        type: 'currency',
        total_value_column: 'Total em Receita Bruta',
      },
      funding_expenses: {
        name: 'Despesas de Custeio/Investimento',
        type: 'currency',
        total_value_column: 'Total em Despesas de Custeio/Investimento',
      },
    },
  },
  exploited_rural_properties_in_brazil: {
    name: 'Dados e Identificação do Imóvel Explorado - Brasil',
    show_pages: false,
    columns: {
      code: { name: 'Código', type: 'integer' },
      participation: { name: 'Participação (%)', type: 'float' },
      exploration_condition: { name: 'Condição de Exploração', type: 'integer' },
      name_and_location: { name: 'Nome e Localização', type: 'name' },
      area: { name: 'Área', type: 'float' },
      cib: { name: 'CIB', type: 'name' },
      participants: {
        name: 'Participantes',
        type: 'inner_table',
        columns: {
          participant_name: { name: 'Participante', type: 'name' },
          foreigner: { name: 'Estrangeiro', type: 'boolean' },
        },
      },
    },
  },
  livestock_movement_in_brazil: {
    name: 'Movimentação do Rebanho - Brasil',
    columns: {
      species: { name: 'Espécie', type: 'name' },
      initial_stock: { name: 'Estoque Inicial', type: 'float' },
      acquisitions: { name: 'Aquisições', type: 'float' },
      births: { name: 'Nascimentos', type: 'float' },
      consumption_and_losses: { name: 'Consumo e Perdas', type: 'float' },
      sales: { name: 'Vendas', type: 'float' },
      final_stock: { name: 'Estoque Final', type: 'float' },
    },
  },
  rural_activity_assets_in_brazil: {
    name: 'Bens da Atividade Rural - Brasil',
    columns: {
      code: { name: 'Código', type: 'name' },
      description: { name: 'Descrição', type: 'name' },
      year_before_last_value: {
        name: 'Valor em 31/12 do Ano Anterior ao Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior ao Anterior',
      },
      last_year_value: {
        name: 'Valor em 31/12 do Ano Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior',
      },
    },
  },
  rural_activity_debts_in_brazil: {
    name: 'Dívidas Vinculadas à Atividade Rural - Brasil',
    columns: {
      item: { name: 'Item', type: 'integer' },
      description: { name: 'Descrição', type: 'name' },
      year_before_last_value: {
        name: 'Valor em 31/12 do Ano Anterior ao Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior ao Anterior',
      },
      last_year_value: {
        name: 'Valor em 31/12 do Ano Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior',
      },
      paid_value_in_last_year: {
        name: 'Valor Pago no Ano Anterior',
        type: 'currency',
        total_value_column: 'Total Pago no Ano Anterior',
      },
    },
  },
  exploited_rural_properties_abroad: {
    name: 'Dados e Identificação do Imóvel Explorado - Exterior',
    show_pages: false,
    columns: {
      code: { name: 'Código', type: 'integer' },
      participation: { name: 'Participação (%)', type: 'float' },
      exploration_condition: { name: 'Condição de Exploração', type: 'integer' },
      name_and_location: { name: 'Nome e Localização', type: 'name' },
      area: { name: 'Área', type: 'float' },
      participants: {
        name: 'Participantes',
        type: 'inner_table',
        columns: {
          participant_name: { name: 'Participante', type: 'name' },
          foreigner: { name: 'Estrangeiro', type: 'boolean' },
        },
      },
    },
  },
  rural_income_and_expenditure_abroad: {
    name: 'Rendimentos e Despesas Rurais - Exterior',
    columns: {
      country_code: { name: 'Código do País', type: 'integer' },
      country_name: { name: 'País', type: 'name' },
      total_gross_revenue_original_currency: {
        name: 'Receita Bruta Total na Moeda Original',
        type: 'currency',
      },
      total_cost_investment_expenses_original_currency: {
        name: 'Despesas Totais de Custeio/Investimento na Moeda Original',
        type: 'currency',
      },
      result_original_currency: { name: 'Resultado na Moeda Original', type: 'currency' },
      result_in_dollars: { name: 'Resultado em Dólares', type: 'currency' },
    },
  },
  rural_activity_assets_abroad: {
    name: 'Bens da Atividade Rural - Exterior',
    columns: {
      code: { name: 'Código', type: 'name' },
      description: { name: 'Descrição', type: 'name' },
      year_before_last_value: {
        name: 'Valor em 31/12 do Ano Anterior ao Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior ao Anterior',
      },
      last_year_value: {
        name: 'Valor em 31/12 do Ano Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior',
      },
    },
  },
  rural_activity_debts_abroad: {
    name: 'Dívidas Vinculadas à Atividade Rural - Exterior',
    columns: {
      item: { name: 'Item', type: 'integer' },
      description: { name: 'Descrição', type: 'name' },
      year_before_last_value: {
        name: 'Valor em 31/12 do Ano Anterior ao Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior ao Anterior',
      },
      last_year_value: {
        name: 'Valor em 31/12 do Ano Anterior',
        type: 'currency',
        total_value_column: 'Total em 31/12 do Ano Anterior',
      },
      paid_value_in_last_year: {
        name: 'Valor Pago no Ano Anterior',
        type: 'currency',
        total_value_column: 'Total Pago no Ano Anterior',
      },
    },
  },
  livestock_movement_abroad: {
    name: 'Movimentação do Rebanho - Exterior',
    columns: {
      species: { name: 'Espécie', type: 'name' },
      initial_stock: { name: 'Estoque Inicial', type: 'float' },
      acquisitions: { name: 'Aquisições', type: 'float' },
      births: { name: 'Nascimentos', type: 'float' },
      consumption_and_losses: { name: 'Consumo e Perdas', type: 'float' },
      sales: { name: 'Vendas', type: 'float' },
      final_stock: { name: 'Estoque Final', type: 'float' },
    },
  },
}
